var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-row',_vm._l((_vm.targets),function(target){return _c('base-col',{key:target.no,attrs:{"cols":"3"}},[_c('target-card',{attrs:{"item":target,"is-no-sales-staff":""},on:{"start":function($event){return _vm.selected(target)}}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }